import { flatten } from 'lodash';
import { useMemo } from 'react';
import { useEventQuestions } from './useEventQuestions';


export function useQARelatedUsers(eventId) {
    const questions = useEventQuestions(eventId);
    return useMemo(() => {
        return flatten(questions.map(question => [question.asker, ...question.answers.data.map(answer => answer.answerer)]));
    }, [questions]);
}
